// CustomButton.js
import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(({ theme }) => ({
  variant: 'contained',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  width: '100%',
  borderRadius: '.5rem',
  height: '2.5rem',
  padding: '0.5rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
  },
  '&:disabled': {
    backgroundColor: theme.palette.background.neutral,
    color: theme.palette.text.secondary,
    opacity: 0.6,
  },
}));

export default function CustomButton({ children, isLoading, ...props }) {
  return (
    <StyledButton {...props}>
      {isLoading ? <CircularProgress size={24} /> : children}
    </StyledButton>
  );
}
